export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13822.9bc6d74a.jpg";